import { Events } from './constants';

export class ChoicesControlValidation {
	constructor(selectComponent) {
		this.component = selectComponent;
		window.od.pubsub.subscribe(
			Events.VALIDATION,
			this.handleValidationFromOwnSelect.bind(this),
		);
	}

	handleValidationFromOwnSelect(e) {
		if (e.payload && e.payload.field === this.component) {
			if (!e.payload.isValid) {
				this.applyErrorStyles(this.component.parentNode);
			} else {
				this.resetStyles(this.component.parentNode);
			}
		}
	}

	applyErrorStyles(element) {
		element.classList.add('od-select__inner--is-invalid');
	}

	resetStyles(element) {
		element.classList.remove('od-select__inner--is-invalid');
		const errorElement = element.parentNode.parentElement.querySelector(
			'.form-inline-row__errors',
		);

		if (errorElement) {
			errorElement.innerHTML = '';
		}
	}
}

function ChoicesControlValidationFactory() {
	const selectElements = document.querySelectorAll(
		'[data-force-validation-for-select-on-blur]',
	);
	if (selectElements.length > 0) {
		Array.from(selectElements).map(
			selectElement => new ChoicesControlValidation(selectElement),
		);
	}

	return selectElements;
}

export default ChoicesControlValidationFactory;
